import {Pipe, PipeTransform} from '@angular/core';
import {stringFormatter} from './stringFormatter';

@Pipe({name: 'numero_licitacao_mask'})
export class NumeroLicitacaoMaskDirective implements PipeTransform {

  transform(originalValue: string, ...args: any[]): string {

    console.log('originalValue', originalValue);

    if (!originalValue || originalValue.length === 0) {
      return '';
    }

    const numberString = stringFormatter.toOnlyPositiveTruncatedNumberString(originalValue);

    if (numberString.length <= 8) {
      return this.formatar4Digitos(numberString);
    }

    return this.formatar6Digitos(numberString);
  }

  private formatar4Digitos(numberString: string): string {

    // Coloca um ponto entre o terceiro e o quarto dígitos
    return numberString.replace(/(\d{4})(\d)/, '$1/$2');
  }

  private formatar6Digitos(numberString: string): string {

    // Adicionando o ponto entre o segundo e terceiro digito
    return numberString.replace(/(\d{6})(\d)/, '$1/$2');
  }

}



// WEBPACK FOOTER //
// ./src/app/util/numero_licitacao-mask.ts